<template>
  <div class="flex flex-col">
    <div><h1>Team wurde angelegt</h1></div>
    <div class="mt-8">
      <img
        class="h-64"
        src="/static/undraw_good_team_m7uu.svg"
      >
    </div>
  </div>
</template>

<script>
export default {
    name: 'TeamCreateCompleted'
}
</script>

<style scoped>

</style>